import React from "react"
import ReactDOM from "react-dom"
import "./index.css"
import App from "./App"
import "semantic-ui-react"
import { BrowserRouter } from "react-router-dom"
// import * as serviceWorker from './serviceWorker';
import dotenv from "dotenv"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

//Yuan redux provider
import { Provider } from "react-redux"
//Redux persist
import { store, persistor } from "./redux/store"
import { PersistGate } from "redux-persist/integration/react"

dotenv.config()

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <PersistGate persistor={persistor}>
        <App />
      </PersistGate>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
